import PropTypes from 'prop-types';

// ---------------------------------------------------------

import Content from '@components/content';
import Jumbotron from '@components/jumbotron';
import Layout from '@layout/index';

// ---------------------------------------------------------

export default function TopicPageTemplate(props) {
  const {
    collection = 'Main',
    pageData,
    preview = false,
    coreService,
    specializedPageSchema
  } = props;

  const collectionHomePathMap = {
    Relocation: '/relocation',
    HomeServices: '/home-services',
    Main: '/'
  };

  return (
    <Layout
      preview={preview}
      collection={collection}
      meta={{
        description: pageData?.metaDescription || pageData?.excerpt,
        image: pageData?.metaImage || pageData?.featuredImage,
        title: pageData?.metaTitle || pageData?.title
      }}
      homePath={collectionHomePathMap[collection] || '/'}
      specializedPageSchema={specializedPageSchema}
    >
      <Jumbotron
        theme={coreService ? 'simple' : 'bar'}
        image={{
          alt: pageData?.headerImage?.alt,
          src: pageData?.headerImage?.url,
          width: pageData?.headerImage?.width,
          height: pageData?.headerImage?.height
        }}
        body={coreService ? pageData?.excerpt : pageData.topic}
        title={pageData.title}
        ctas={coreService && pageData.headerCtAsCollection?.items}
      />
      <Content isBlockCollection content={pageData.body} />
    </Layout>
  );
}

TopicPageTemplate.propTypes = {
  collection: PropTypes.oneOf(['Relocation', 'Mortgage', 'Main']).isRequired,
  pageData: PropTypes.object.isRequired,
  preview: PropTypes.bool,
  coreService: PropTypes.bool
};
